import React, { FC } from 'react';
import { ComponentRendering, isEditorActive, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import HeroSectionText from './components/heroSectionText';
import HeroSectionCarousel from './components/heroSectionCarousel';
import { TContentHubProductModelDetailHeroSectionProps } from './types/productModelDetailHeroSection.types';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import useSitecoreContext from '../../hooks/useSitecoreContext';

const ProductModelDetailHeroSection: FC<TContentHubProductModelDetailHeroSectionProps> = (props) => {
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);
  const apiResponse = isEmptyResponse(props);
  const {sitecoreContext} = useSitecoreContext();
  const isEEActive = sitecoreContext?.pageEditing;

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <section>
        <Placeholder name="jss-breadcrumb" rendering={props?.rendering} />
        <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
      </section>
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent
      rendering={props?.rendering as ComponentRendering}
      title={props.fields?.apiData?.title ?? props.fields?.apiData?.eyebrow ?? ''}
      template="Hero Section"
    >
      <section className="product-hero-section">
        {(isEEActive ||
          (props.rendering?.placeholders?.['jss-breadcrumb'] && props.rendering?.placeholders?.['jss-breadcrumb']?.length > 0)) && (
          <div className="product-hero-section__placeholder">
            <div className="product-hero-section__placeholder__container">
              <Placeholder name="jss-breadcrumb" rendering={props.rendering} />
            </div>
          </div>
        )}
        <div className="product-hero-section__container">
          <HeroSectionCarousel fields={props.fields} />
          <HeroSectionText fields={props.fields} params={props.params} />
        </div>
      </section>
    </AnalyticsVisibleEvent>
  );
};

export default ProductModelDetailHeroSection;
